export default __webpack_public_path__ + "static/media/yuval-dayan_sherak-techaiech.eadcc074.mp3";